import { apiFetch } from './client.js';
import type { ApprovalReadiness } from './onboarding.api.js';

export type { ApprovalReadiness };

/**
 * Customer-level KYC decisions, taken from Customer 360 (Approve KYC, keep the
 * EDD restriction). The KYC Queue and its list, case and reject calls are gone
 * (DEV-160): applications under review are worked from Onboarding.
 */
export const kycApi = {
  /** The conditions the approve route enforces, so the UI can show them first. */
  caseReadiness: (customerId: string): Promise<ApprovalReadiness> =>
    apiFetch<ApprovalReadiness>(`/admin/kyc/cases/${customerId}/readiness`),

  approveCase: (customerId: string, reason: string): Promise<{ success: boolean }> =>
    apiFetch<{ success: boolean }>(`/admin/kyc/cases/${customerId}/approve`, {
      method: 'POST',
      body: { reason },
    }),

  /** Records the decision to keep a customer in EDD required (DEV-112); the status does not change. */
  keepEddRestriction: (customerId: string, reason: string): Promise<{ customerId: string; status: string }> =>
    apiFetch<{ customerId: string; status: string }>(`/admin/kyc/cases/${customerId}/keep-edd`, {
      method: 'POST',
      body: { reason },
    }),
};
